<!-- 🔹 Backlink Builder Script -->
document.addEventListener("DOMContentLoaded", function() {
    const referrer = document.referrer;
    const trackedReferrers = {
      'example-backlink-site.com': 'Example Backlink Site',
      'another-important-site.com': 'Another Important Site',
      'referral-site.com': 'Referral Site'
    };

    if (referrer && !referrer.includes("clearo.co.uk")) {
      // Server-side logging
      fetch("https://your-server.com/log-backlink", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          backlink: referrer,
          page: window.location.href,
          timestamp: new Date().toISOString()
        })
      });

      // Generic GA event
      if (window.gtag) {
        gtag("event", "backlink_visit", {
          event_category: "SEO",
          event_label: referrer,
          value: 1
        });

        // Targeted GA events with custom labels
        Object.keys(trackedReferrers).forEach(domain => {
          if (referrer.includes(domain)) {
            gtag("event", "backlink_visit", {
              event_category: "Referral Traffic",
              event_label: trackedReferrers[domain],
              value: 1
            });
          }
        });
      }
    }
  });
